import { Component, Input } from '@angular/core';

@Component({
    selector: 'radio',
    templateUrl: 'radio.html',
    styleUrls: ['../field-abstract/icon-field.scss', 'radio.scss']
})
export class RadioComponent {
    @Input()
    middle = false;
}
